import React, { useState } from 'react';
import { usePageViewEvents } from '../../../../../../../../core/Analytics/usePageViewEvents';
import { AwaitingScenario } from '../../../../../../../../models/credentials';
import { ProviderEntity } from '../../../../../../../../models/provider';
import { PageView, UserInteractionEvent } from '../../../../../../../../models/analytics';
import { InteractionElement } from '../../../../../../../../core/Analytics/ParentApplicationEventMessenger';
import { SubmitCredentialsScreenBankIDMobileView } from './SubmitCredentialsScreenBankIDMobileView';
import { SubmitCredentialsScreenBankIDDesktopView } from './SubmitCredentialsScreenBankIDDesktopView';

export type MutualProps = {
  provider: ProviderEntity;
  onHeaderButtonClick: () => void;
};

export type DesktopProps = MutualProps & {
  remoteDeviceAction: () => void;
};

export type MobileProps = MutualProps & {
  awaitingScenario: AwaitingScenario;
  paymentDetails?: React.ReactNode;
  localDeviceAction: () => void;
  remoteDeviceAction: () => void;
};

export const SubmitCredentialsScreenBankIDMobile: React.FC<MobileProps> = ({
  localDeviceAction,
  remoteDeviceAction,
  provider,
  onHeaderButtonClick,
  awaitingScenario,
  paymentDetails,
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { sendViewInteractionEvent } = usePageViewEvents({
    pageView: PageView.SUBMIT_CREDENTIALS_SCREEN_BANKID,
  });

  const onSubmitRemoteDeviceAction = () => {
    sendViewInteractionEvent({
      interaction: UserInteractionEvent.SECONDARY_BUTTON,
      element: InteractionElement.SECONDARY_BUTTON,
    });
    setIsLoading(true);
    remoteDeviceAction();
  };

  const onSubmitLocalDeviceAction = () => {
    sendViewInteractionEvent({
      interaction: UserInteractionEvent.PRIMARY_BUTTON,
      element: InteractionElement.PRIMARY_BUTTON,
    });
    setIsLoading(true);
    localDeviceAction();
  };

  return (
    <SubmitCredentialsScreenBankIDMobileView
      onBack={onHeaderButtonClick}
      onClickLocal={onSubmitLocalDeviceAction}
      onClickRemote={onSubmitRemoteDeviceAction}
      isLoading={isLoading}
      provider={provider}
      awaitingScenario={awaitingScenario}
      paymentDetails={paymentDetails}
    />
  );
};

export const SubmitCredentialsScreenBankIDDesktop: React.FC<DesktopProps> = ({
  remoteDeviceAction,
  provider,
  onHeaderButtonClick,
}) => {
  const { sendViewInteractionEvent } = usePageViewEvents({
    pageView: PageView.SUBMIT_CREDENTIALS_SCREEN_BANKID,
  });

  const onClickHandle = () => {
    sendViewInteractionEvent({
      interaction: UserInteractionEvent.PRIMARY_BUTTON,
      element: InteractionElement.PRIMARY_BUTTON,
    });

    remoteDeviceAction();
  };

  return (
    <SubmitCredentialsScreenBankIDDesktopView
      onBack={onHeaderButtonClick}
      onClick={onClickHandle}
      provider={provider}
    />
  );
};
